import script from "./GNM11.vue?vue&type=script&setup=true&lang=js"
export * from "./GNM11.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__